import { ref, type Ref } from "vue";
import type FormCC from "@/interface/FormCC";
import type FormCCOtp from "@/interface/FormCCOtp";
import MasterService from "@/service/restfulService/CCOnboardMasterService";

export default function checkBiometricFlag(
  ccFormValue: Ref<FormCC>,
  prop: any,
  flag: Ref<string>,
  otp: Ref<FormCCOtp>,
  bioExist: Ref<boolean>,
  page0Overlay: Ref<boolean>,
  creditLimit: Ref<string>,
  isTimeOut: Ref<boolean>,
  isSessionEnd: Ref<boolean>,
  failedStatus: Ref<boolean>,
  cifErrorFlag: Ref<boolean>,
  jumpStep: (value: number, name: string, page: string) => void
): void {
  if (ccFormValue.value.isDraft || flag.value == "true") {
    if (otp.value.verified == "true" || cifErrorFlag.value) {
      if (ccFormValue.value.ekyc.preStatus != "") {
        if (bioExist.value == true) {
          page0Overlay.value = false;
          jumpStep(4, "", "3");
        } else {
          const requestModel = {
            webFormRequestId: ccFormValue.value.webFormRequestId,
            name: ccFormValue.value.basicInformation.name,
            icNo: ccFormValue.value.basicInformation.idNo,
            dateOfBirth: ccFormValue.value.basicInformation.dob,
            cardBusinessCode: prop.cardId,
            nationalityCode: ccFormValue.value.basicInformation.nationality,
            phoneNo:
              ccFormValue.value.basicInformation.countryCode +
              ccFormValue.value.basicInformation.mobileNo,
            grossIncome:
              ccFormValue.value.basicInformation.grossSalary.toString(),
            netIncome: ccFormValue.value.basicInformation.netSalary.toString(),
            refNo: ccFormValue.value.refNo,
          };
          MasterService.preAssesment(requestModel, ccFormValue.value.token)
            .then((res) => {
              if (res.status == 200) {
                // page3Overlay.value = false;
                ccFormValue.value.preAss.webFormRequestId =
                  res.data.responseModel.webFormRequestId;
                ccFormValue.value.dsrBurst = res.data.responseModel.dSRStatus;
                ccFormValue.value.dropOffStep = 5;
                creditLimit.value = res.data.responseModel.preAssessLimit;
                ccFormValue.value.ctosScore = res.data.responseModel.ctosScore;
                if (res.data.responseModel.preAssessStatus == "DECLINED") {
                  page0Overlay.value = false;
                  jumpStep(14, "denied2", "3");
                } else {
                  ccFormValue.value.ekyc.preStatus =
                    res.data.responseModel.preAssessStatus;
                  page0Overlay.value = false;
                  jumpStep(4, "", "3");
                }
              }
            })
            .catch((e) => {
              if (e.response && e.response.data.code == "WB-401") {
                // EndSession
                isTimeOut.value = false;
                isSessionEnd.value = true;
              }
              page0Overlay.value = false;
              ccFormValue.value.ekyc.preStatus = "DOWN";
              jumpStep(4, "", "3");
            });
        }
      } else {
        const requestModel = {
          webFormRequestId: ccFormValue.value.webFormRequestId,
          name: ccFormValue.value.basicInformation.name,
          icNo: ccFormValue.value.basicInformation.idNo,
          dateOfBirth: ccFormValue.value.basicInformation.dob,
          cardBusinessCode: prop.cardId,
          nationalityCode: ccFormValue.value.basicInformation.nationality,
          phoneNo:
            ccFormValue.value.basicInformation.countryCode +
            ccFormValue.value.basicInformation.mobileNo,
          grossIncome:
            ccFormValue.value.basicInformation.grossSalary.toString(),
          netIncome: ccFormValue.value.basicInformation.netSalary.toString(),
          refNo: ccFormValue.value.refNo,
        };
        MasterService.preAssesment(requestModel, ccFormValue.value.token)
          .then((res) => {
            if (res.status == 200) {
              // page3Overlay.value = false;
              ccFormValue.value.preAss.webFormRequestId =
                res.data.responseModel.webFormRequestId;
              ccFormValue.value.dsrBurst = res.data.responseModel.dSRStatus;
              ccFormValue.value.dropOffStep = 5;
              creditLimit.value = res.data.responseModel.preAssessLimit;
              ccFormValue.value.ctosScore = res.data.responseModel.ctosScore;
              if (res.data.responseModel.preAssessStatus == "DECLINED") {
                page0Overlay.value = false;
                jumpStep(14, "denied2", "3");
              } else {
                ccFormValue.value.ekyc.preStatus =
                  res.data.responseModel.preAssessStatus;
                page0Overlay.value = false;
                jumpStep(4, "", "3");
              }
            }
          })
          .catch((e) => {
            if (e.response && e.response.data.code == "WB-401") {
              // EndSession
              isTimeOut.value = false;
              isSessionEnd.value = true;
            }
            page0Overlay.value = false;
            ccFormValue.value.ekyc.preStatus = "DOWN";
            jumpStep(4, "", "3");
          });
      }
    } else {
      page0Overlay.value = false;
      jumpStep(3, "", "1");
    }
  } else {
    if (
      ccFormValue.value.ekyc.status == "" ||
      ccFormValue.value.ekyc.status == "PENDING" ||
      ccFormValue.value.ekyc.status == "FAILED"
    ) {
      failedStatus.value = false;
      page0Overlay.value = false;
      if (ccFormValue.value.basicInformation.idType == "0") {
        ccFormValue.value.ekyc.action = "N";
        jumpStep(2, "", "1");
      } else if (otp.value.verified == "true") {
        jumpStep(4, "", "1");
      } else {
        jumpStep(3, "", "1");
      }
    } else {
      if (otp.value.verified == "true") {
        if (ccFormValue.value.ekyc.preStatus != "") {
          if (bioExist.value == true) {
            page0Overlay.value = false;
            jumpStep(4, "", "3");
          } else {
            const requestModel = {
              webFormRequestId: ccFormValue.value.webFormRequestId,
              name: ccFormValue.value.basicInformation.name,
              icNo: ccFormValue.value.basicInformation.idNo,
              dateOfBirth: ccFormValue.value.basicInformation.dob,
              cardBusinessCode: prop.cardId,
              nationalityCode: ccFormValue.value.basicInformation.nationality,
              phoneNo:
                ccFormValue.value.basicInformation.countryCode +
                ccFormValue.value.basicInformation.mobileNo,
              grossIncome:
                ccFormValue.value.basicInformation.grossSalary.toString(),
              netIncome:
                ccFormValue.value.basicInformation.netSalary.toString(),
              refNo: ccFormValue.value.refNo,
            };
            MasterService.preAssesment(requestModel, ccFormValue.value.token)
              .then((res) => {
                if (res.status == 200) {
                  // page3Overlay.value = false;
                  ccFormValue.value.preAss.webFormRequestId =
                    res.data.responseModel.webFormRequestId;
                  ccFormValue.value.dsrBurst = res.data.responseModel.dSRStatus;
                  ccFormValue.value.dropOffStep = 5;
                  creditLimit.value = res.data.responseModel.preAssessLimit;
                  ccFormValue.value.ctosScore =
                    res.data.responseModel.ctosScore;
                  if (res.data.responseModel.preAssessStatus == "DECLINED") {
                    page0Overlay.value = false;
                    jumpStep(14, "denied2", "3");
                  } else {
                    ccFormValue.value.ekyc.preStatus =
                      res.data.responseModel.preAssessStatus;
                    page0Overlay.value = false;
                    jumpStep(4, "", "3");
                  }
                }
              })
              .catch((e) => {
                if (e.response && e.response.data.code == "WB-401") {
                  // EndSession
                  isTimeOut.value = false;
                  isSessionEnd.value = true;
                }
                page0Overlay.value = false;
                ccFormValue.value.ekyc.preStatus = "DOWN";
                jumpStep(4, "", "3");
              });
          }
        } else {
          page0Overlay.value = false;
          jumpStep(4, "", "1");
        }
      } else {
        page0Overlay.value = false;
        jumpStep(3, "", "1");
      }
    }
  }
}
